import { createMap } from "../omnia"
import { Field } from "./types"

export function getFieldKey(groupKey: string, fieldId: number) {
    return groupKey ? `${groupKey}:${fieldId}` : String(fieldId)
}

export function parseFieldKey(key: string) {
    if (key) {
        const p = key.lastIndexOf(':')
        return p >= 0
            ? Number(key.substring(p + 1))
            : Number(key)
    }
}

export function getFieldProvider(fields: Field[]) {

    return getProvider(
        fields,
        f => f.fieldId,
        fieldId => ({
            fieldId,
            name: `Unknown field #${fieldId}`,
            area: 0,
            cropping: []
        })
    )

}


function getProvider<T>(items: T[], keySelector: (a: T) => number, getDefault: (id: number) => T) {

    const map = createMap(items, keySelector)

    return (id: number) => {

        let item = map.get(id)

        if (!item) {
            item = getDefault(id)
            map.set(id, item)
        }

        return item

    }

}
